import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { loadExternalResources } from '../state/actions'
import { externalPortalsCacheKey } from './cache-keys'
import { DashboardCatalogInfo } from '../components/catalog/types'

export const useGetExternalResources = (onSuccess?: (data: DashboardCatalogInfo) => void) => {
  const dispatch = useDispatch()

  return useQuery(
    externalPortalsCacheKey(),
    async () => {
      const { Data } = await dispatch(loadExternalResources())
      return Data
    },
    { onSuccess, refetchOnWindowFocus: false }
  )
}
